module.exports = __webpack_public_path__ + "img/Binom.134af0bb.png";